import { omit } from 'lodash'
import { Input } from './Input'

export const Textarea = {
  variants: {
    outline: Input.variants.outline.field,
  },
  sizes: {
    md: omit(Input.sizes.md.field, 'height'),
    sm: omit(Input.sizes.sm.field, 'height'),
    xs: omit(Input.sizes.xs.field, 'height'),
  },
}
